export const translations = {};
